import React from 'react';
import { AwardIcon, ArrowRightIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import { Link } from 'react-router-dom';
export function AboutSection() {
  return <section id="akademie" className="py-16 md:py-24 bg-white" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <ScrollReveal variant="up" data-id="element-30">
          <div className="text-center max-w-3xl mx-auto mb-12 md:mb-20" data-id="element-31">
            <h2 className="text-3xl md:text-5xl font-extrabold text-slate-700 mb-6 tracking-tight" data-id="element-32">
              Willkommen bei der 2N – Ihrem Fortbildungsinstitut in Nürnberg
            </h2>
            <p className="text-base sm:text-lg text-slate-500 leading-relaxed font-medium" data-id="element-33">
              Die Akademie für zahnärztliche Fortbildung ist Ihre Anlaufstelle,
              wenn Sie nach qualifizierter Weiterbildung und innovativen
              Kursformaten in der Zahnmedizin suchen. Unser Anspruch ist es,
              Zahnärzten, Oralchirurgen und Praxisteams praxisnahe,
              zertifizierte Weiterbildung zu ermöglichen.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 mb-16" data-id="element-34">
          <ScrollReveal variant="up" delay={100} data-id="element-35">
            <div className="relative rounded-3xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group min-h-[320px] flex flex-col justify-end" data-id="element-36">
              <img src="https://cdn.rawproductionsgmbh.de/2n/home/curriculum.jpeg" alt="Praxisnahes Curriculum" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-37" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20" data-id="element-38"></div>
              <div className="relative z-10 p-6 sm:p-10" data-id="element-39">
                <h3 className="text-2xl font-extrabold text-white mb-4 tracking-tight" data-id="element-40">
                  Praxisnahes Curriculum
                </h3>
                <p className="text-white/80 font-medium leading-relaxed" data-id="element-41">
                  Unser Herzstück ist das Curriculum Zahnmedizin, das aktuelle
                  wissenschaftliche Erkenntnisse mit direkter Umsetzbarkeit im
                  Praxisalltag verbindet.
                </p>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={200} data-id="element-42">
            <div className="relative rounded-3xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group min-h-[320px] flex flex-col justify-end" data-id="element-43">
              <img src="https://cdn.rawproductionsgmbh.de/2n/akurs/akurs-1.jpg" alt="Für alle Erfahrungsstufen" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-44" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20" data-id="element-45"></div>
              <div className="relative z-10 p-6 sm:p-10" data-id="element-46">
                <h3 className="text-2xl font-extrabold text-white mb-4 tracking-tight" data-id="element-47">
                  Für alle Erfahrungsstufen
                </h3>
                <p className="text-white/80 font-medium leading-relaxed" data-id="element-48">
                  Sie profitieren von einem modular aufgebauten Programm, das
                  sowohl Einsteiger als auch erfahrene Kollegen gezielt fördert
                  und weiterbringt.
                </p>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={300} data-id="element-49">
            <div className="relative rounded-3xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group min-h-[320px] flex flex-col justify-end" data-id="element-50">
              <img src="https://cdn.rawproductionsgmbh.de/2n/bkurs/bkurs-1.jpg" alt="Anerkannte Fortbildungspunkte" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-51" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20" data-id="element-52"></div>
              <div className="relative z-10 p-6 sm:p-10" data-id="element-53">
                <h3 className="text-2xl font-extrabold text-white mb-4 tracking-tight" data-id="element-54">
                  Anerkannte Fortbildungspunkte
                </h3>
                <p className="text-white/80 font-medium leading-relaxed" data-id="element-55">
                  Als anerkannte Akademie erhalten Sie bei jedem Kurs offiziell
                  bescheinigte Fortbildungspunkte für Zahnärzte zur Erfüllung
                  Ihrer Nachweispflichten.
                </p>
              </div>
            </div>
          </ScrollReveal>
        </div>

        <ScrollReveal variant="up" delay={400} data-id="element-56">
          <div className="text-center mb-16 md:mb-24" data-id="element-57">
            <Link to="/kontakt" className="inline-flex items-center justify-center px-6 py-3.5 text-base sm:px-8 sm:py-4 sm:text-lg font-bold rounded-md text-white bg-[#3b7780] hover:bg-[#2d5f66] transition-all hover:scale-105 shadow-lg" data-id="element-58">
              Jetzt Kursplan sichern
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-59" />
            </Link>
          </div>
        </ScrollReveal>

        {/* Fortbildungspunkte Highlight Section */}
        <ScrollReveal variant="scale" data-id="element-60">
          <div className="bg-[#1a1a1a] rounded-[2rem] overflow-hidden shadow-2xl relative" data-id="element-61">
            <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-62">
              <div className="p-6 sm:p-10 md:p-12 lg:p-20 flex flex-col justify-center relative z-10" data-id="element-63">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/20 text-amber-400 text-sm font-extrabold uppercase tracking-wider mb-8 w-fit" data-id="element-64">
                  <AwardIcon className="h-5 w-5" data-id="element-65" />
                  Offizieller Nachweis
                </div>
                <h3 className="text-3xl md:text-4xl font-extrabold text-white mb-6 tracking-tight" data-id="element-66">
                  Fortbildungspunkte für Zahnärzte einfach sammeln
                </h3>
                <p className="text-[#748282] mb-6 leading-relaxed font-medium text-base sm:text-lg" data-id="element-67">
                  Unsere Programme sind von den Zahnärztekammern zertifiziert
                  und unterstützen Sie dabei, Ihre jährlichen Nachweispflichten
                  zuverlässig zu erfüllen. Nach erfolgreicher Teilnahme erhalten
                  Sie ein offizielles Zertifikat über die erreichten
                  Fortbildungspunkte.
                </p>
                <p className="text-[#59d0d4] font-bold text-base sm:text-lg" data-id="element-68">
                  So verbinden Sie nachhaltiges Lernen mit optimaler Compliance.
                </p>
              </div>
              <div className="relative h-80 lg:h-auto min-h-[320px] overflow-hidden" data-id="element-69">
                <img src="https://cdn.rawproductionsgmbh.de/2n/home/fortbildungen.jpg" alt="Zahnärztliche Fortbildung Praxis" className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-1000" data-id="element-70" />
                <div className="absolute inset-0 bg-[#1a1a1a]/40" data-id="element-71"></div>
                <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a] to-transparent lg:w-1/2" data-id="element-72"></div>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}